'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var label = '',
        classList = this.compileStyle(_index2.default);

    if (this.props.label) {
        label = _react2.default.createElement(
            'div',
            { className: classList.text },
            this.props.label
        );
    } else if (this.props.children) {
        label = _react2.default.createElement(
            'div',
            { className: classList.text },
            this.props.children
        );
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement(
            'div',
            { className: classList.wrapper },
            _react2.default.createElement(
                'div',
                { className: classList.container },
                _react2.default.createElement(
                    'svg',
                    { viewBox: '26 26 52 52' },
                    _react2.default.createElement('circle', {
                        className: classList.containerPath,
                        cx: '52px',
                        cy: '52px',
                        r: '20px',
                        fill: 'none',
                        strokeWidth: '4px'
                    })
                )
            )
        ),
        label
    );
}